import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: "AIzaSyCyvKrKTkqIyAFviyGn0FUOnYKcLNNCmaE",
  authDomain: "dotslash-exambnb.firebaseapp.com",
  projectId: "dotslash-exambnb",
  storageBucket: "dotslash-exambnb.appspot.com",
  messagingSenderId: "656621459934",
  appId: "1:656621459934:web:99f25830bb8ae48024a54f",
  measurementId: "G-T0LNJ9G6LC",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();